module.exports = __webpack_public_path__ + "img/hyper.de9aeb95.svg";